import { getTenantFromHostname } from '../utils/tenant.util';

// Extract tenant from hostname - throws error if extraction fails (app will halt)
const tenant = getTenantFromHostname();

// Construct tenant-based URLs for staging
const apiUrl = `https://${tenant}.auth.staging.timestaging.com`;
const accountingUrl = `https://${tenant}.accounts.staging.timestaging.com`;
const authUrl = `https://${tenant}.auth.staging.timestaging.com`;
const pdfUrl = `https://${tenant}.pdf.staging.timestaging.com`;
const assetUrl = `https://${tenant}.asset.staging.timestaging.com`;
const cssdUrl = `https://${tenant}.cssd.staging.timestaging.com`;
const bmwUrl = `https://${tenant}.bmw.staging.timestaging.com`;

export const environment = {
  production: true, // Staging uses production-like settings
  apiUrl,
  accountingUrl,
  assetUrl,
  authUrl,
  pdfUrl,
  cssdUrl,
  bmwUrl,
  encryptionKey: 'staging-key-change-in-production',
  sessionTimeout: 20 * 60 * 1000, // 20 minutes for staging
  features: {
    enableMFA: true,
    enableRateLimiting: true
  },
  security: {
    maxLoginAttempts: 5,
    lockoutDuration: 20 * 60 * 1000, // 20 minutes
    passwordMinLength: 10,
    requireSpecialChars: true
  }
};

